module.exports = __webpack_public_path__ + "static/media/next-generation.3cb89803.jpg";